'use strict'
/*
 * Use this file to call functions in other files, on document ready, window.resize etc.
 */

var twentyninetimes = twentyninetimes || {}

// Document ready
document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    svg4everybody() // Fix SVG spritemap in IE/Edge
  })

  twentyninetimes.siteHeader.init()
  twentyninetimes.navigation.init()
  twentyninetimes.accordion.init()
  twentyninetimes.loadMore.init()
  twentyninetimes.inView.init()
  twentyninetimes.oembedToggle.init()
  twentyninetimes.slider.init()
  twentyninetimes.anchorScroll.init()
  twentyninetimes.maps.init()
  twentyninetimes.dropdown.init()
  //twentyninetimes.formular.init();
  twentyninetimes.blockCheckout.init()
  twentyninetimes.rankMathFaq.init()
  twentyninetimes.readmore.init()
  twentyninetimes.imageComparison.init()
  twentyninetimes.archiveFilter.init()
  twentyninetimes.faq.init()
  twentyninetimes.testimonials.init()
  twentyninetimes.uspAccordion.init()
  twentyninetimes.employeesServiceCenterToggle.init()
  twentyninetimes.blockHero.init();

  var inViewItems = document.querySelectorAll(
    '.scroll-item, .site-content:not(.no-scroll-anim) .container-inside > *:not(.wp-block-group), .site-content:not(.no-scroll-anim) .wp-block-group .wp-block-group__inner-container > *'
  )
  if (inViewItems && inViewItems.length != 0) {
    var test = (item) => {
      if (!item.classList.contains('in-view')) {
        item.classList.add('in-view')
      }
    }
    twentyninetimes.inView.init(inViewItems, test, -100)
  }

  const urlHash = window.location.hash
  if (urlHash) {
    const urlHashElement = document.querySelector(urlHash)

    if (urlHashElement) {
      urlHashElement.scrollIntoView({ behavior: 'smooth' })
    }
  }

  var groupsPatternBg = document.querySelectorAll(
    '.wp-block-group.is-style-bg-pattern-tooth'
  )

  if (groupsPatternBg) {
    groupsPatternBg.forEach((group) => {
      var pattern = document.createElement('SPAN')
      pattern.setAttribute('class', 'wp-block-group__bg-pattern')

      group.prepend(pattern)
    })
  }

  var clinicSearch = document.getElementById('clinic-map-search'),
    radios = document.querySelectorAll(
      'input[type=radio][name=clinic-map-radio]'
    ),
    clinicsWrapper = document.querySelector('.loop-clinic-map')

  if (clinicsWrapper && clinicSearch) {
    const items = clinicsWrapper.querySelectorAll('.item-clinic-map')
    const titles = clinicsWrapper.querySelectorAll('.item-clinic-map__title')

    clinicSearch.addEventListener('input', (e) => {
      clinicSearchResults(e)
    })

    if (radios) {
      radios.forEach((radio) => {
        radio.addEventListener('input', (e) => {
          clinicSearchResults(e)
        })
      })
    }

    function clinicSearchResults(e) {
      const searchValue = e.target.value.toLowerCase();

      items.forEach((item) => {
        const itemText = item.innerText.toLowerCase();
        const searchTerms = item.getAttribute('data-search-terms')
          ? item.getAttribute('data-search-terms').toLowerCase().split(',').map(term => term.trim())
          : [];

        const matches =
          itemText.includes(searchValue) ||
          searchTerms.some(term => term.includes(searchValue)) ||
          !searchValue;

        if (matches) {
          item.classList.remove('js-map-item--hidden');
        } else {
          item.classList.add('js-map-item--hidden');
        }
      });
    }
  }

  var employeesFull = document.querySelector('.block-employees-full')

  if (employeesFull) {
    // const inputs = document.querySelectorAll(
    //   '.js-dropdown input[name="clinic_id"]'
    // )
    // const clinicLists = document.querySelectorAll('.block-employees-full__list')
    // if (inputs) {
    //   inputs.forEach((input) => {
    //     const clinicURL = input.getAttribute('data-url')
    //     input.addEventListener('input', (e) => {
    //       // var radioValue = e.target.value
    //       // redirect to clinic page
    //       if (clinicURL) {
    //         window.location.href = clinicURL
    //       }
    //       // if (clinicLists) {
    //       //   clinicLists.forEach((clinicList) => {
    //       //     var clinicId = clinicList.getAttribute('data-clinic-id')
    //       //     if (clinicId == radioValue) {
    //       //       clinicList.classList.remove('hidden')
    //       //     } else {
    //       //       clinicList.classList.add('hidden')
    //       //     }
    //       //   })
    //       // }
    //     })
    //   })
    // }
  }

  var priceCalculator = document.getElementById('price-calculator')
  var priceCalculatorValidateText = document.getElementById(
    'price-calculator-validate-text'
  )

  if (priceCalculator && window.innerWidth > 991) {
    var doc = document.documentElement,
      w = window,
      scrollTop = window.pageYOffset,
      curScroll,
      calculatorFromTop =
        scrollTop + priceCalculator.getBoundingClientRect().top - 90
  }

  if (
    priceCalculator &&
    priceCalculatorValidateText &&
    window.innerWidth < 992
  ) {
    var btn = priceCalculator.querySelector('.btn')

    if (btn) {
      btn.addEventListener('click', function () {
        btn.classList.add('show-validate')
        priceCalculatorValidateText.classList.add('show-validate')
      })
    }
  }

  // Scroll functions
  window.onscroll = function () {
    twentyninetimes.siteHeader.checkScroll()

    if (calculatorFromTop) {
      curScroll = w.scrollY || doc.scrollTop

      curScroll > calculatorFromTop
        ? priceCalculator.classList.add('sticky')
        : priceCalculator.classList.remove('sticky')
    }
  }

  // Resize functions
  window.onresize = function () {
    window.onscroll()

    document
      .querySelectorAll(
        '.js-comparison-slider .js-comparison-before .comparison-slider__before-inset'
      )
      .forEach((image_before) => {
        let containerWidth = image_before.closest(
          '.js-comparison-slider'
        ).offsetWidth

        image_before.style.width = `${containerWidth}px`
      })
  }

  window.onresize()
})
